import { functions } from '../../config/firebase'
import { getCallableErrorMessage } from '../ProductsSyncMenu/syncDateUtils'

const listSmsMessages = async (payload = {}) => {
  try {
    const callable = functions.httpsCallable('listSmsMessages')
    const result = await callable(payload)
    return { ok: true, data: result.data }
  } catch (error) {
    console.error('[listSmsMessages] failed:', error)
    return {
      ok: false,
      message: getCallableErrorMessage(error),
      code: error?.code || null,
    }
  }
}

export default listSmsMessages
